import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OutcomesPerStudentReport from '@instructure/outcomes-ui/es/containers/OutcomesPerStudentReport';
import { liveRegion } from '@instructure/quiz-common';
import CustomPropTypes from '../../../../common/util/CustomPropTypes';
export var OutcomeAnalysis = /*#__PURE__*/function (_Component) {
  function OutcomeAnalysis() {
    _classCallCheck(this, OutcomeAnalysis);
    return _callSuper(this, OutcomeAnalysis, arguments);
  }
  _inherits(OutcomeAnalysis, _Component);
  return _createClass(OutcomeAnalysis, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        quizId = _this$props.quizId,
        contextUuid = _this$props.contextUuid,
        outcomesHost = _this$props.outcomesHost,
        outcomesToken = _this$props.outcomesToken,
        loadUsersOverride = _this$props.loadUsersOverride,
        showRollups = _this$props.showRollups;
      return /*#__PURE__*/React.createElement(OutcomesPerStudentReport, {
        artifactType: "quizzes.quiz",
        artifactId: quizId,
        contextUuid: contextUuid,
        host: outcomesHost,
        jwt: outcomesToken,
        loadUsersOverride: loadUsersOverride,
        showRollups: showRollups,
        screenreaderNotification: this.props.screenreaderNotification,
        liveRegion: liveRegion
      });
    }
  }]);
}(Component);
/**
 ---
 category: components
 name: OutcomeAnalysis
 ---
 SDK Outcome Analysis Report component

 A component to show outcomes results

 ```jsx_example
 function Example () {
    return (
      <SDKApp
        apiEndpoint={`http://${config.API_HOST}`}
        appContainer="#app"
        userToken={config.TOKEN_QUIZ_BUILD}
        outcomesEndpoint={`http://${config.OUTCOMES_HOST}`}
        outcomesToken={config.TOKEN_OUTCOMES_REPORT}
      >
        <OutcomeAnalysis quizId='1' />
      </SDKApp>
    )
  }

 <SettingsSwitcher locales={LOCALES}>
 <Example />
 </SettingsSwitcher>
 ```
 */
_defineProperty(OutcomeAnalysis, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  quizId: PropTypes.string.isRequired,
  contextUuid: PropTypes.string.isRequired,
  outcomesHost: PropTypes.string.isRequired,
  outcomesToken: PropTypes.string.isRequired,
  loadUsersOverride: PropTypes.func,
  showRollups: PropTypes.bool,
  screenreaderNotification: PropTypes.func.isRequired
});
_defineProperty(OutcomeAnalysis, "defaultProps", {
  loadUsersOverride: void 0,
  showRollups: true
});
export default OutcomeAnalysis;